import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-edit-view"},[_c(VCard,[_c(VCardActions,[_c(VBtn,{attrs:{"text":"","color":"primary"},on:{"click":function($event){return _vm.$router.back()}}},[_c(VIcon,{attrs:{"left":""}},[_vm._v("arrow_back")]),_vm._v("\n        Back\n      ")],1)],1),_c(VCardTitle,{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Edit order")])]),_c(VCardText,[_c('OrderForm',{attrs:{"updatableOrder":_vm.order}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }